<template>
  <div class="Mouths">    
    <svg viewBox="0 0 1686.22 2248.29">  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_01'" d="M952.72,1026.47s-56,22-63.06,22.46-40.08,2.64-48,0-65.09-19.82-65.09-19.82l5.29,21.1s32.55,11.51,45,16.07c-3.25,9.18-9.94,27.76-12.21,31.87-3,5.51-8.13,29.56-8.13,29.56s13.62,16,32.54,20,60.42,0,60.42,0,25.64-19,25.64-25c0-5.72-11.6-58.12-12.73-63.23,20.31-8.62,46.49-20.62,47.35-20.91C961.09,1038.12,952.72,1026.47,952.72,1026.47Zm-87.13,42.42c4.95,0,9.74-.08,13.8-.19l-13.55,51.49Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_02'" d="M772.13,1043.64l7.07,28.27h20.31l5.3-32.69h17.67l3.48,33.63,33.27-3.53-1.42-30.1h16.86l6.65,34.19,22.08,5s3.88-24.14,4.76-30.32,21.2-.89,21.2-.89-2.65,26.5,0,30,29.15-1.77,30-4.42,5-31.45,5-31.45S925,1031.27,902,1030.39s-117-7.38-119.61-5.62S772.13,1043.64,772.13,1043.64Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_02'" d="M806.08,1082.86c-2.2,2.21-3.57,29.15-3.57,29.15s20.36,6.63,29.19,8.39,69.34,2.65,69.34,2.65,29.59-8.39,31.36-9.27-7.51-27.39-7.51-27.39l-19,.45L898,1103l-15.17-1.55-9.56-21.2-16.34,2.21-1.77,27.82-24.73-4.85-6.19-21.65Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_03'" d="M796.74,1074.51s32.8-28.86,38-32.8S865,1064,867.58,1058.77s24.93-19.68,34.11-22.3,38,44.6,38,44.6-38,17.06-51.17,22.3-53.78,0-53.78,0Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_04'" d="M771.74,1056.61c2,0,78-8,78-8s13,10,18,10,26-13,26-13,21,13,28,14,43,2,43,2-58,37-67,39-44,8-60,4S771.74,1056.61,771.74,1056.61Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_05'"  d="M974.65,1024.47s-60,30.86-82,25.65-63.54-21.06-63.54-21.06c-25.35,2.37-68.59,4.09-68.59,4.09s9.16,41.11,27.57,57.21,94.47,40.93,101.91,39,54.79-32.15,73.15-45.8S974.65,1024.47,974.65,1024.47ZM904.56,1101c-11.6.68-58.66-5.44-58.66-5.44l-54.75-33.44c3.16.12,39-13.22,40.94-9.84s36.65,21.2,46.08,22.65,39.82-10.3,44.06-11.25,27.92-3.7,27.92-3.7S916.17,1100.32,904.56,1101Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_06'" d="M755.7,1055s57.61,3.14,73.28,3.14S877.2,1069,877.2,1069l32.55-10.84h71s-35.11,59.14-56.81,62.76-96.62,5.92-112.29-4.93S755.7,1055,755.7,1055Z"/>  
      <polygon class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_07'" points="939.27 1070.88 898.29 1097.5 818.09 1098.61 797.21 1067.67 939.27 1070.88"/>
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_08'" d="M954.35,1049s-60.67,13.8-95.88,15.22-76.66-6-76.66-6,.46,55.52,10.48,73,74.83,47.39,84.74,44.41,69.49-26.78,74.29-63S954.35,1049,954.35,1049Zm-43.84,65.07c-1.8,6.52-32.22,23.2-37.08,22.86s-31-5-41-13.81-22.28-36.21-22.28-36.21,38.85,2.68,47.14,5S916,1079.47,916,1079.47,912.3,1107.53,910.51,1114.05Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_09'" d="M874.89,1029.36c-12.78-4.95-34.92-7.92-42.67,0s-21.56,48.55-20.11,56.48,36.13,44.83,44.06,51.15,55.48,8.3,63.41-6.56,4.95-71.34,0-86.2S874.89,1029.36,874.89,1029.36Z"/>  
      <path class="cls-1" :class="color_used" v-if="this.portrait.mouths == 'mouth_10'" d="M774.86,1056.84s32.58,35.67,42.71,44.26,57.51,10.53,60.25,10.22,54.25-17.81,62.18-27.23,21.14-34.52,21.14-34.52,16.66,6.61,16.26,13.87S959.82,1115,938,1124.87s-74.64,19.82-89.18,18.5-59.45-23.16-68-32-21.73-47.88-21.73-47.88Z"/>  
       
      <!-- <path class="cls-1" :class="color_used" v-if="this.portrait.hair == 'hair_16'"  -->

    </svg>
  </div>
</template>

<script>

export default {
  name: 'Mouths',
  data: ()=>({
    indice: 'mouths',
    default_color: 'grey',
    color_used: 'grey',
  }),
  computed: { 
    categorie() { return this.$store.getters['app/categorie'] },
    portrait() { return this.$store.getters['app/portrait'] },
    color() { return this.$store.getters['app/color'] },
    reset_color() { return this.$store.getters['app/reset_color'] },
    colors() { return this.$store.getters['app/colors'] },
  },
    mounted() {
    if(this.colors[this.indice]) 
      this.color_used = this.colors[this.indice]
  },
  watch: {
    color(nw, od) {
      if(this.categorie == this.indice) {
        this.color_used = nw
      }
    },
    reset_color(nw, od) {
      if(this.categorie == this.indice) {
        this.color_used = this.default_color
      }
    },
    categorie(nw, od) {
      this.$nextTick(()=>{
        if(nw == this.indice)
          this.$store.commit('app/SET_COLOR', this.color_used)
      })
    },

  },

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Mouths
  default_color = grey
  svg
    width 100%
    .cls-1 
      fill default_color
      &.green 
        fill asset_green
      &.dark_blue 
        fill asset_dark_blue
      &.orange 
        fill asset_orange
      &.purple 
        fill asset_purple
      &.yellow 
        fill asset_yellow
      &.blue 
        fill asset_blue
      &.pink 
        fill asset_pink
      &.dark_brown 
        fill asset_dark_brown
      &.brown 
        fill asset_brown
      &.red 
        fill asset_red

</style>


// WEBPACK FOOTER //
// src/components/defis/svg/Mouths.vue